import React from 'react';
import classNames from 'clsx';

import { InputLabelProps } from './InputLabel.interfaces';
import { useStyles } from './InputLabel.styles';

export default function InputLabel({
  className,
  children,
  floated,
  floating,
  filled,
  disabled,
  focused,
  error,
  inputId,
  withoutHtmlFor,
}: InputLabelProps) {
  const classes = useStyles();

  return (
    <label
      {...(!withoutHtmlFor && { htmlFor: inputId })}
      className={classNames(classes.root, className, 'transform', {
        [classes.floated]: floated,
        [classes.floating]: floating,
        [classes.notFloating]: !floating,
        [classes.filled]: filled,
        [classes.disabled]: disabled,
        [classes.error]: error,
        [classes.focused]: focused,
      })}
      aria-disabled={disabled}
      aria-invalid={error}
      id={`${inputId}-label`}
    >
      {children}
    </label>
  );
}
